var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg87(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 14.33,
    cy: 12.23,
    r: 11.52
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 33.57,
    cy: 5.98,
    r: 5.27
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.11,23.74l1.52-8.84c0,0,0.58-3.39,4.84-2.67c0,0,2.45,0.87,2.38,4.19l-2.53,14.87L30.11,23.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.08,12.69c0,0,1.37,0.33,0.79,5.6l3.68-3.97c0,0,1.3-2.82-1.95-3.47L41.08,12.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.41,29.01l14.44,16.82c0,0,3.47,1.06,3.03-3.28L27.8,26.01C27.8,26.01,23.68,24.5,24.41,29.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.08,28.18c0,0,0.36,2.53,1.44,3.39l4.12,4.98l-3.47-0.7l-9.39,10.8c0,0-6.28,1.08-4.48-5.7l9.89-11.95L21.08,28.18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg87);
export default __webpack_public_path__ + "static/media/87.0fded8ad13c874788a4d3a93336f7264.svg";
export { ForwardRef as ReactComponent };